<div class="container-fluid metric-settings-container mosaic-material-theme">
  <settings-nav
    [settingsNavItemData]="metricSettingsNavItemData"
    (navItemClicked)="navItemClicked($event)"
    [pageTitle]="'Metric Settings'"
  ></settings-nav>
  <metric-settings-body></metric-settings-body>
</div>
